import type { ManualCategory, ManualDoc } from "./types.ts"
import { t } from "./content/t.ts"
import { START_DOCS } from "./content/start.ts"
import { SHIPPER_DOCS } from "./content/shipper.ts"
import { WAREHOUSE_DOCS } from "./content/warehouse.ts"
import { FINDING_DOCS } from "./content/finding.ts"
import { REFERENCE_DOCS } from "./content/reference.ts"

/**
 * 매뉴얼의 목차.
 *
 * 문서를 하나 더하려면 `content/` 의 해당 파일에 항목을 하나 넣으면 된다.
 * 분류를 더하려면 여기 한 줄과 새 파일 하나 — 화면 코드는 건드리지 않는다.
 */
export const MANUAL_CATEGORIES: ManualCategory[] = [
  { slug: "start", order: 1, title: t("시작하기", "はじめに") },
  { slug: "shipper", order: 2, title: t("화주가 하는 일", "荷主の作業") },
  { slug: "warehouse", order: 3, title: t("쿨트랙JP가 하는 일", "日本側の作業") },
  { slug: "finding", order: 4, title: t("찾기와 목록", "検索と一覧") },
  { slug: "reference", order: 5, title: t("참고", "リファレンス") },
]

export const MANUAL_DOCS: ManualDoc[] = [
  ...START_DOCS,
  ...SHIPPER_DOCS,
  ...WAREHOUSE_DOCS,
  ...FINDING_DOCS,
  ...REFERENCE_DOCS,
]

export type { Block, Localized, ManualCategory, ManualDoc } from "./types.ts"
